<script lang="ts">
  import Share from "~icons/ph/chats";

  const {
    addUrl,
  }: {
    addUrl: string;
  } = $props();
</script>

<div class="rounded bg-white p-4 pl-3 lg:p-6 lg:pl-5 border-l-4 border-0 border-solid border-info">
  <h2 class="ui-title mb-1">
    Friends don't let friends get <span class="whitespace-nowrap">ripped off</span>
  </h2>

  <p class="text-base mb-4 text-gray-600">
    Do you know anyone who has financed a vehicle since April 2007? <b>They may have a claim!</b> We'll check their eligibility
    and help them file their claim, too.
  </p>

  <button class="btn btn-secondary w-full sm:w-auto mb-4">
    <Share class="w-5 h-5 relative -top-[1px]" />
    Share with a friend
  </button>

  <a class="block text-gray-600" href={addUrl} target="_blank" rel="noopener">
    Did you finance another vehicle?
    <span class="underline font-bold text-primary">Find more claims in seconds&hellip;</span>
  </a>
</div>
